
import { defineComponent } from 'vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import helpers from '../../../utils/helpers'
import consumer from 'src/utils/action_cable_consumer'

import { mapActions } from 'vuex'

export default defineComponent({
  name: 'request-expiration-date',
  components: { NrIconButton, NrTooltip, NrModal, NrFormInput, NrIcon },
  props: {
    prettyId: { type: String },
    exempt: { type: Boolean },
    expiration: { type: String }
  },
  data() {
    return {
      showModal: false,
      updating: false,
      newExempt: this.exempt,
      exemptedDocuments: false,
      subscription: null,
      currentJobId: null
    }
  },

  mounted() {
    this.subscribeToUserJobChannel()
  },

  unmounted() {
    this.unsubscribeToUserJobChannel()
  },

  methods: {
    ...mapActions('request_show', ['updateRequest', 'fetchTimeline']),
    ...mapActions('documents', ['bulkDocumentActions']),

    subscribeToUserJobChannel() {
      const self = this
      this.subscription = consumer.subscriptions.create(
        // Subscribe to channel
        {
          channel: 'UserJobChannel',
          user_id: this.$store.state.currentUser.id
        },
        {
          received(data) {
            if (data.job_type !== 'exempt_from_retention') return
            if (data.job_id !== self.currentJobId) return

            self.setupToastMessage(data)
          }
        }
      )
    },

    unsubscribeToUserJobChannel() {
      if (consumer.connection.isOpen()) {
        consumer.subscriptions.remove(this.subscription)
      }
    },

    setupToastMessage(data) {
      if (helpers.backgroundJobComplete(data.status)) {
        this.setSuccessToastMessage()
        this.fetchTimeline({ pretty_id: this.prettyId })
      } else if (helpers.backgroundJobFailed(data.status)) {
        this.setFailedToastMessage()
      }
    },

    setSuccessToastMessage() {
      this.$toasted.success('Successfully updated document(s) retention status')
    },

    setFailedToastMessage() {
      this.$toasted.error('Failed to update document(s) retention status')
    },

    async handleSaveExempt() {
      this.updating = true
      try {
        await this.updateRequest({
          request_id: this.prettyId,
          exempt_from_retention: this.newExempt
        })
        this.$toasted.success('Successfully updated request retention status')
      } catch (error) {
        this.$toasted.error('Failed to update request retention status')
        this.updating = false
      }

      if (this.exemptedDocuments) {
        try {
          await this.bulkDocumentActions({
            bulk_action: 'update_exempt_from_retention',
            all_selected: true,
            request_id: this.prettyId,
            exempt_from_retention: true
          }).then((xhr) => {
            if (xhr.status === 200) {
              const data = xhr.response ? xhr.response.body.data : xhr.data
              this.currentJobId = data.jobId[0]
            }
          })
          this.$toasted.show('Document(s) retention status processing')
        } catch (error) {
          this.$toasted.error('Failed to update document(s) retention status')
          this.updating = false
        }
      }
      this.fetchTimeline({ pretty_id: this.prettyId })

      this.exemptedDocuments = false
      this.updating = false
      this.toggleModal(false)
    },

    toggleModal(state?: boolean) {
      this.showModal = state ?? !this.showModal
    }
  }
})
